// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-post-market-monitoring.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-post-market-monitoring',
  title: 'Operate post-market monitoring and serious-incident reporting for high-risk AI',
  description:
    'Confirm that providers of high-risk AI systems establish and document a post-market monitoring system proportionate to the nature of the AI technologies and the risks of the system (EU AI Act Art. 72), and report serious incidents to the competent market-surveillance authority within the statutory timelines: any serious incident within 15 days of awareness; widespread infringement or serious and irreversible disruption of critical infrastructure within 2 days; fatality within 10 days (Art. 20, Art. 73). Investigations under Art. 79 and corrective actions shall be documented. Review the post-market monitoring plan, the incident register and the notification records.',
  category: 'incidents',
  scfIds: ['SCF-AIG-016'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Post-market monitoring plan is published' },
    { type: 'document-approved', description: 'Plan has been approved' },
    { type: 'document-within-sla', description: 'Plan review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
